var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative"},[_c('avatar-display',{staticClass:"mr-3",attrs:{"avatar":_vm.avatar,"options":_vm.avatarOptions}}),_vm._v(" "),_c('div',{class:{'online-status': true, 'is-online': _vm.online}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }